import { render, staticRenderFns } from "./Impostazioni.vue?vue&type=template&id=46c1d818&scoped=true&"
import script from "./Impostazioni.vue?vue&type=script&lang=js&"
export * from "./Impostazioni.vue?vue&type=script&lang=js&"
import style0 from "./Impostazioni.vue?vue&type=style&index=0&id=46c1d818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c1d818",
  null
  
)

export default component.exports